// Kâr / Zarar / Marj için tutarlı renk + etiket eşleme mantığı.
// Kullanım: profitTone(value) veya marginTone(margin, minMargin)

/** Return {tone, label, className} for a monetary profit/loss value. */
export function profitTone(value) {
  if (value === null || value === undefined) return { tone: "neutral", label: "-", className: "text-slate-500" };
  const n = typeof value === "number" ? value : parseFloat(value);
  if (Number.isNaN(n)) return { tone: "neutral", label: "-", className: "text-slate-500" };
  if (n > 0) return { tone: "success", label: "Kâr", className: "text-emerald-700" };
  if (n < 0) return { tone: "danger", label: "Zarar", className: "text-rose-700" };
  return { tone: "neutral", label: "Sıfır", className: "text-slate-600" };
}

/**
 * Margin tone with a "low margin" warning threshold.
 * minMargin: percentage number (e.g. 20 for 20%).
 * value: margin percentage (e.g. 15.5) — number or string.
 */
export function marginTone(value, minMargin) {
  if (value === null || value === undefined) return { tone: "neutral", label: "-", className: "text-slate-500" };
  const n = typeof value === "number" ? value : parseFloat(value);
  if (Number.isNaN(n)) return { tone: "neutral", label: "-", className: "text-slate-500" };
  const min = typeof minMargin === "number" ? minMargin : parseFloat(minMargin);
  if (n < 0) return { tone: "danger", label: "Zarar", className: "text-rose-700" };
  if (n === 0) return { tone: "neutral", label: "Sıfır", className: "text-slate-600" };
  if (!Number.isNaN(min) && n < min) return { tone: "warning", label: "Düşük Marj", className: "text-amber-700" };
  return { tone: "success", label: "Kâr", className: "text-emerald-700" };
}

/** Background chip class for badges based on tone. */
export const TONE_CHIP = {
  success: "bg-emerald-100 text-emerald-800 border border-emerald-200",
  warning: "bg-amber-100 text-amber-800 border border-amber-200",
  danger: "bg-rose-100 text-rose-800 border border-rose-200",
  info: "bg-blue-100 text-blue-800 border border-blue-200",
  neutral: "bg-slate-100 text-slate-700 border border-slate-200",
};
